import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function FlagFillIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M20.0371 0.748047L18.8037 1.63379C16.355 3.39356 14.4292 2.88086 12.2002 2.28516C9.78284 1.64148 7.08527 0.926267 4.1485 3.78443L3.92285 2.76075L1.96973 3.19044L6.31983 22.9287L8.27295 22.499L6.85205 16.0517C9.3587 12.8896 11.2693 13.0969 13.6641 13.3701C16.0029 13.6357 18.6533 13.9385 21.7998 11.082L22.229 10.6924L20.0371 0.748047Z",
    fill: "currentColor"
  }));
}